import { defineStore } from "pinia";

export const useMenuStore = defineStore("menuStore", {
  state: () => ({
    isActive: false,
  }),
  actions: {
    active() {
      this.isActive = !this.isActive;
    },
    setInactive() {
      this.isActive = false;
    },
  },
  //persist: true,
});
